import getConfig from 'next/config'
import { useRouter } from 'next/router'

// public/ assets are only reachable via the CDN assetPrefix in deployed environments —
// www.telus.com does not route origin-relative paths to this app, and Next only applies
// the assetPrefix to _next/* chunks on its own. Must resolve on the server too: React
// does not patch attribute mismatches during hydration, so a server-rendered fallback
// URL would stick for the lifetime of the page.
export const getRuntimeAssetPrefix = (basePath: string): string => {
  if (typeof window !== 'undefined') {
    return window.__NEXT_DATA__?.assetPrefix || basePath
  }
  return getConfig()?.publicRuntimeConfig?.ASSET_PREFIX || basePath
}

export const useRuntimeAssetPrefix = (): string => {
  const { basePath } = useRouter()
  return getRuntimeAssetPrefix(basePath)
}
